import { render, staticRenderFns } from "./NextLastArtcle.vue?vue&type=template&id=907fe0a4&scoped=true&"
import script from "./NextLastArtcle.vue?vue&type=script&lang=js&"
export * from "./NextLastArtcle.vue?vue&type=script&lang=js&"
import style0 from "./NextLastArtcle.vue?vue&type=style&index=0&id=907fe0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907fe0a4",
  null
  
)

export default component.exports